import { StoriesI } from '../interfaces/stories.interface'
import { StoriesService } from '../services/stories.service'
import {
    StoriesCreateStoryResponseT,
    StoriesCreateStorySlideResponseT,
    StoriesGetListResponseT,
    StoriesGetStoryResponseT,
    StoriesGetStorySlidesResponseT,
    StoryPayloadT,
} from '../types/stories.types'

const storiesService = new StoriesService()

class StoriesRealisation implements StoriesI {
    getList(page: number): Promise<StoriesGetListResponseT> {
        return storiesService.getList(page)
    }

    getStory(story_id: number): Promise<StoriesGetStoryResponseT> {
        return storiesService.getStory(story_id)
    }

    createStory(payload: StoryPayloadT): Promise<StoriesCreateStoryResponseT> {
        return storiesService.createStory(payload)
    }

    updateStory(story_id: number, payload: StoryPayloadT): Promise<StoriesCreateStoryResponseT> {
        return storiesService.updateStory(story_id, payload)
    }

    publishStory(story_id: number): Promise<void> {
        return storiesService.publishStory(story_id)
    }

    unpublishStory(story_id: number): Promise<void> {
        return storiesService.unpublishStory(story_id)
    }

    deleteStory(story_id: number): Promise<void> {
        return storiesService.deleteStory(story_id)
    }

    getStorySlides(story_id: number): Promise<StoriesGetStorySlidesResponseT> {
        return storiesService.getStorySlides(story_id)
    }

    createStorySlide(
        story_id: number,
        payload: FormData
    ): Promise<StoriesCreateStorySlideResponseT> {
        return storiesService.createStorySlide(story_id, payload)
    }

    updateStorySlide(
        story_id: number,
        payload: FormData
    ): Promise<StoriesCreateStorySlideResponseT> {
        return storiesService.updateStorySlide(story_id, payload)
    }

    deleteStorySlide(slide_id: number): Promise<void> {
        return storiesService.deleteStorySlide(slide_id)
    }
}

export const stories = new StoriesRealisation()
